import type { IconSvgObject } from './types';

const LayerAddIcon: IconSvgObject = [
  ["path", { d: "M9 11C9 9.89543 9.89543 9 11 9H20C21.1046 9 22 9.89543 22 11V20C22 21.1046 21.1046 22 20 22H11C9.89543 22 9 21.1046 9 20V11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 15.5L13 15.5M15.5 13V18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 9V4C17 2.89543 16.1046 2 15 2H4C2.89543 2 2 2.89543 2 4V15C2 16.1046 2.89543 17 4 17H8.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LayerAddIcon;
